const _WalletsABI = JSON.parse(
  '[{"constant":false,"inputs":[{"name":"verifiedWallet","type":"address"}],"name":"VerifyRequest","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"requestID","type":"bytes32"}],"name":"RequestVerification","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"newForwarder","type":"address"}],"name":"UpdateForwarder","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"sender","type":"address"},{"name":"verifiedWallet","type":"address"}],"name":"ForwardedVerifyRequest","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"revokedWallet","type":"address"}],"name":"RevokeVerification","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"sender","type":"address"},{"name":"requestID","type":"bytes32"}],"name":"ForwardedRequestVerification","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"VerificationRequests","outputs":[{"name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"sender","type":"address"},{"name":"revokedWallet","type":"address"}],"name":"ForwardedRevokeVerification","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"VerifiedWallets","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[{"name":"administratorContract","type":"address"},{"name":"forwarderContract","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"wallet","type":"address"},{"indexed":false,"name":"requestID","type":"bytes32"}],"name":"NewRequest","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"wallet","type":"address"}],"name":"VerifiedRequest","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"wallet","type":"address"}],"name":"RevokedVerification","type":"event"}]'
);
const _WalletsAddress = '0x78c41350337ff27a538a55fc7eaeae59951deb38';

function CreateWalletContract(contract_address, _Web3, opts) {
  if (typeof opts != 'object') {
    if (typeof opts != 'undefined') {
      throw new Error(
        'Wallets Contract Options must be undefined or an object'
      );
    } else {
      opts = {};
    }
  }

  if (typeof contract_address == 'undefined' || contract_address === null) {
    contract_address = _WalletsAddress;
  } else if (typeof contract_address != 'string') {
    throw new Error('Wallets Contract Address must be a String');
  } else if (typeof _Web3 != 'object') {
    throw new Error('Web3 Must be defined for Wallets Contract creation');
  } else {
    var WalletsContract = {
      isVerified: createCheckVerification(contract_address, _Web3, opts),
      requestVerification: createRequestVerification(
        contract_address,
        _Web3,
        opts
      ),
      checkRequest: createCheckRequest(contract_address, _Web3, opts)
    };
    return WalletsContract;
  }
}

function debugOut(debugToConsole, message) {
  if (debugToConsole) {
    console.log(message);
  }
}

function createCheckVerification(contract_address, _Web3, opts) {
  if (typeof opts != 'object') {
    opts = {};
  }
  if (typeof contract_address != 'string') {
    throw new Error('Token Address must be a string');
  } else if (typeof _Web3 != 'object') {
    throw new Error('Web3 must be an Object');
  } else {
    return wallet_contract_check_verification;
  }
  function wallet_contract_check_verification(wallet_address, callback) {
    const walletsContract = _Web3.eth
      .contract(_WalletsABI)
      .at(contract_address);

    //console.log(walletsContract);
    walletsContract.VerifiedWallets.call(wallet_address, function(
      error,
      result
    ) {
      if (error) {
        console.error(error);
        callback(error);
      } else {
        callback(null, result);
      }
    });
  }
}

function createRequestVerification(contract_address, _Web3, opts) {
  if (typeof opts != 'object') {
    opts = {};
  }
  if (typeof contract_address != 'string') {
    throw new Error('Token Address must be a string');
  } else if (typeof _Web3 != 'object') {
    throw new Error('Web3 must be an Object');
  } else {
    return wallet_contract_request_verification;
  }

  function wallet_contract_request_verification(requestCode, callback) {
    debugOut(opts.debug, 'Requesting Verification...');
    const walletsContract = _Web3.eth
      .contract(_WalletsABI)
      .at(contract_address);
    walletsContract.RequestVerification.sendTransaction(requestCode, function(
      error,
      result
    ) {
      if (error) {
        console.error(error);
        callback(error);
      } else {
        callback(null, result);
      }
    });
  }
}

function createCheckRequest(contract_address, _Web3, opts) {
  if (typeof opts != 'object') {
    opts = {};
  }
  if (typeof contract_address != 'string') {
    throw new Error('Token Address must be a string');
  } else if (typeof _Web3 != 'object') {
    throw new Error('Web3 must be an Object');
  } else {
    return wallet_contract_check_request;
  }

  function wallet_contract_check_request(address, callback) {
    debugOut(opts.debug, 'Checking Verification...');
    const walletsContract = _Web3.eth
      .contract(_WalletsABI)
      .at(contract_address);
    walletsContract.VerificationRequests.call(address, function(error, result) {
      if (error) {
        console.error(error);
        callback(error);
      } else {
        callback(null, result);
      }
    });
  }
}

export default CreateWalletContract;
